var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-178 375.1 53.8 50",
    style: {
      enableBackground: "new -178 375.1 53.8 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C3580;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-130.8,385.4h-14.7v-4.1l-22.3,3.9v30.3l22.3,3.9v-3.6h14.7c0.6,0,1-0.5,1-1v-28.4 C-129.8,385.9-130.2,385.4-130.8,385.4z M-153.6,406.8l-2.5-0.2l-1.9-9.1c-0.1,0.2-1.8,8.9-1.8,8.9l-2.3-0.2l-2.2-11.3l2.1-0.2 c0,0,1.4,8.8,1.4,8.9l1.9-9.2l2.3-0.2c0,0,1.8,9.3,1.8,9.5l1.7-9.7l2.4-0.2L-153.6,406.8z M-131,414.6L-131,414.6h-14.5v-3h11.2 v-1.8h-11.2v-2.3h11.2v-1.7h-11.2v-2.3h11.2v-1.7h-11.2v-2.3h11.2v-1.7h-11.2v-2.3h11.2v-1.7h-11.2v-2.3h11.2v-1.7h-11.2V387h14.5 V414.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.8a42ee700f6bcee2861e3f03162a8067.svg";
export { ForwardRef as ReactComponent };